import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';

import Button from '../../../../shared/_TBComponents/Button';
import { setRegisteringWithSSO } from '../../../login/ducks/loginActions';
import Text from '../../../../shared/_TBComponents/Text';

const ConnectedFormGroup = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const CurrentlyRegisteringContainer = styled('div')`
  align-items: center;
  align-self: center;
  background-color: #EFF6FC;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 25px;
  padding: 15px;
  text-align: center;
  width: 400px;
`;

const SSOSection = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  const dispatch = useDispatch();
  const theme = useTheme();

  const handleSSODisconnect = () => {
    dispatch(setRegisteringWithSSO(false));
  };

  return (
    <ConnectedFormGroup>
      <CurrentlyRegisteringContainer>
        <Text styledTextProps={{ fontWeight: '700' }}>
          Connected with
          {' '}
          {currentUser.ssoName}
        </Text>
        <Text styledWrapperProps={{ marginBottom: '10px' }}>
          You will be able to sign in with your
          {' '}
          {currentUser.ssoName}
          {' '}
          account.
          We just need a few additional details to complete your registration.
        </Text>
        <Button
          bgColor={theme.colors.lightBlue}
          fontSize='14px'
          name='Disconnect'
          noBorder
          onClick={handleSSODisconnect}
          rounded
          txtColor={theme.colors.white}
          type='button'
          upperCase
        />
      </CurrentlyRegisteringContainer>
    </ConnectedFormGroup>
  );
};

export default SSOSection;
